import React from "react";
import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import Separator from "../Separator";
import { CommonButton } from "../../common/CommonButton";
import { StackActions, useNavigation } from "@react-navigation/native";
import SvgImage from "../choose-avatar-components/SvgImage";

interface StreamSetupPopupProps {
  screen?: string;
  showPopup: boolean;
  setShowPopup?: (value: boolean) => void;
  onClose?: () => void;
}

const StreamSetupPopup: React.FC<StreamSetupPopupProps> = ({
  screen,
  showPopup,
  setShowPopup,
  onClose,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const navigation = useNavigation();
  return (
    showPopup && (
      <Modal visible={showPopup} transparent={true} animationType="fade">
        <View
          style={{
            flex: 1,
            backgroundColor: AppColors.blackTrans_000000a8,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View
            style={{
              padding: 12,
              borderRadius: 12,
              backgroundColor: AppColors.purple_453B50,
              gap: 12,
              alignItems: "center",
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "90%"
                  : "50%",
            }}
          >
            <SvgImage src={AppImages.icLive} variant="liveImage" />
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_16, { textAlign: "center" }]}
            >
              Streaming Setup Not Available on Mobile
            </Text>
            <Text
              style={[AppFontStyle.MEDIUM_ANYBODY_14, { textAlign: "center" }]}
            >
              To configure and stream, please use a desktop or laptop.
            </Text>
            <CommonButton
              buttonStyle={{
                paddingVertical: 10,
                paddingHorizontal: 14,
                backgroundColor: AppColors.white,
                borderRadius: 8,
                shadowOpacity: 0,
                borderWidth: 2,
                borderColor: AppColors.white,
              }}
              fontStyle={[
                AppFontStyle.SEMIBOLD_ANYBODY_14,
                { color: AppColors.gray_414651 },
              ]}
              title="Back"
              image={true}
              imageUrl={AppImages.icBlockLeftArrow}
              imageStyle={{ width: 20, height: 20, resizeMode: "contain" }}
              onTap={() => {
                if (onClose) {
                  onClose();
                } else if (screen === "LiveStream") {
                  setShowPopup && setShowPopup(false);
                } else {
                  navigation.dispatch(StackActions.pop());
                }
              }}
            />
          </View>
        </View>
      </Modal>
    )
  );
};

export default StreamSetupPopup;

const useStyles = CreateResponsiveStyle(
  {},
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
